export class IssueIndentDisplay {
    pharmacyIssueHeaderId: number;
    pharmacyIndentHeaderId: number;
    pharmacyIssueDetailId: number;
    pharmacyProductId: number;
    retailStockId: number;
    createdBy: number;
    productName: string;
    createdDate: Date;
    overallNetAmount: number;
    overallGst: number;
    overallDiscount: number;
    gstPercentage: number;
    discountPercentage?: number;
    discountAmount?: number;
    netAmount: number;
    gstAmount: number;
    quantity: number;
    expiryDate: number;
    overallTotal: number;
    total: number;
    retailName: string;
}